import { TransactionArchivePage } from '../features/settings/TransactionArchivePage';
import { GodownSalesReportPage } from '../features/sales/GodownSalesReportPage';
import { BranchGodownStockReportPage } from '../features/inventory/BranchGodownStockReportPage';
import { GraniteInvoicePage } from '../features/sales/GraniteInvoicePage';
import { GraniteStockPage } from '../features/inventory/GraniteStockPage';
import { BackupRestorePage } from '../features/settings/BackupRestorePage';
import { createBrowserRouter } from 'react-router-dom';
import { MainLayout } from '../layouts/MainLayout';
import { DashboardLayout } from '../layouts/DashboardLayout';
import { ProtectedRoute } from '../auth/ProtectedRoute';
import { LoginPage } from '../pages/auth/LoginPage';
import { OverviewPage } from '../pages/OverviewPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { UsersPage } from '../features/users/UsersPage';
import { RolesPage } from '../features/roles/RolesPage';
import { RoleEditorPage } from '../features/roles/RoleEditorPage';
import { DepartmentsPage } from '../features/departments/DepartmentsPage';
import { OrgEntityPage } from '../features/organization/OrgEntityPage';
import { ORG_ENTITIES } from '../features/organization/config';
import { SettingsPage } from '../features/settings/SettingsPage';
import { AuditLogPage } from '../features/audit/AuditLogPage';
import { ProfilePage } from '../features/profile/ProfilePage';
import { CatalogEntityPage } from '../features/catalog/CatalogEntityPage';
import { CATALOG_ENTITIES } from '../features/catalog/config';
import { ProductsPage } from '../features/products/ProductsPage';
import { PurchaseRatesPage } from '../features/products/PurchaseRatesPage';
import { SellingPricesPage } from '../features/products/SellingPricesPage';
import { ProductWeightsPage } from '../features/products/ProductWeightsPage';
import { ProductAuditPage } from '../features/products/ProductAuditPage';
import { ProfitReportPage } from '../features/sales/ProfitReportPage';
import { FastMovingReportPage, ProductSalesReportPage, ProductTransactionReportPage, SalesmanSalesReportPage } from '../features/sales/SalesAnalyticsPage';
import { IncentiveReportPage } from '../features/sales/IncentiveReportPage';
import { IncentiveAssignPage } from '../features/sales/IncentiveAssignPage';
import { IncentiveProductListPage } from '../features/sales/IncentiveProductListPage';
import { PartyEntityPage } from '../features/parties/PartyEntityPage';
import { PARTY_ENTITIES } from '../features/parties/config';
import { LogisticsPage } from '../features/logistics/LogisticsPage';
import { LOGISTICS_ENTITIES } from '../features/logistics/config';
import { StockPage } from '../features/inventory/StockPage';
import { StockCheckPage } from '../features/inventory/StockCheckPage';
import { ProductStockCheckPage } from '../features/inventory/ProductStockCheckPage';
import { ProductActivityReportPage } from '../features/inventory/ProductActivityReportPage';
import { StockCountPage } from '../features/inventory/StockCountPage';
import { StockVerificationReportPage } from '../features/inventory/StockVerificationReportPage';
import { SmartStockCheckPage } from '../features/inventory/SmartStockCheckPage';
import { TransfersPage } from '../features/inventory/TransfersPage';
import { TransferPrintPage } from '../features/inventory/TransferPrintPage';
import { StockReportsPage } from '../features/inventory/StockReportsPage';
import { AllGodownStockReportPage } from '../features/inventory/AllGodownStockReportPage';
import { MultiGodownStockReportPage } from '../features/inventory/MultiGodownStockReportPage';
import { InactiveProductStockReportPage } from '../features/inventory/InactiveProductStockReportPage';
import { PurchaseOrdersPage } from '../features/purchase/PurchaseOrdersPage';
import { DeliveryAddressesPage } from '../features/purchase/DeliveryAddressesPage';
import { GoodsReceiptsPage } from '../features/purchase/GoodsReceiptsPage';
import { PurchaseInvoicesPage } from '../features/purchase/PurchaseInvoicesPage';
import { PurchaseReturnsPage } from '../features/purchase/PurchaseReturnsPage';
import { PurchaseGstPage } from '../features/purchase/PurchaseGstPage';
import { SupplierPaymentsPage } from '../features/purchase/SupplierPaymentsPage';
import { SupplierLedgerPage } from '../features/purchase/SupplierLedgerPage';
import { PayablesPage } from '../features/purchase/PayablesPage';
import { NumberSeriesPage } from '../features/settings/NumberSeriesPage';
import { AccessCalendarPage } from '../features/settings/AccessCalendarPage';
import { SixOrbitSettingsPage } from '../features/sixorbit/SixOrbitSettingsPage';
import { ProductImportPage } from '../features/sixorbit/ProductImportPage';
import { ProductMasterExportPage } from '../features/sixorbit/ProductMasterExportPage';
import { SixOrbitStockExportPage } from '../features/sixorbit/SixOrbitStockExportPage';
import { SyncConsolePage } from '../features/sixorbit/SyncConsolePage';
import { PendingJobsPage } from '../features/sixorbit/PendingJobsPage';
import { AccountsPage } from '../features/accounts/AccountsPage';
import { CashBookPage } from '../features/accounts/CashBookPage';
import { DayClosePage } from '../features/accounts/DayClosePage';
import { ExpenseHeadsPage } from '../features/accounts/ExpenseHeadsPage';
import { OwnerStatementPage } from '../features/accounts/OwnerStatementPage';
import { QuotationsPage } from '../features/sales/QuotationsPage';
import { QuotationEntryPage } from '../features/sales/QuotationEntryPage';
import { QuotationPrintPage } from '../features/sales/QuotationPrintPage';
import { ReceiptPrintPage } from '../features/sales/ReceiptPrintPage';
import { SalesInvoicePrintPage } from '../features/sales/SalesInvoicePrintPage';
import { CollectionsPage } from '../features/sales/CollectionsPage';
import { CustomerLedgerPage } from '../features/sales/CustomerLedgerPage';
import { GstSummaryPage } from '../features/sales/GstSummaryPage';
import { OutstandingPage } from '../features/sales/OutstandingPage';
import { CustomerAdvancesPage } from '../features/sales/CustomerAdvancesPage';
import { SalesInvoicesPage } from '../features/sales/SalesInvoicesPage';
import { DeliverySlipsPage } from '../features/sales/DeliverySlipsPage';
import { SalesReturnsPage } from '../features/sales/SalesReturnsPage';
import { SalesReturnPrintPage } from '../features/sales/SalesReturnPrintPage';
import { SalesOrdersPage } from '../features/sales/SalesOrdersPage';
import { GatePassesPage } from '../features/dispatch/GatePassesPage';
import { GatePassEntryPage } from '../features/dispatch/GatePassEntryPage';
import { GatePassPrintPage } from '../features/dispatch/GatePassPrintPage';
import { DispatchReportsPage } from '../features/dispatch/DispatchReportsPage';
import { DriverCashPage } from '../features/dispatch/DriverCashPage';
import { LeadsPage } from '../features/crm/LeadsPage';
import { CampaignsPage } from '../features/crm/CampaignsPage';
import { SalesVisitsPage } from '../features/crm/SalesVisitsPage';
import { PortalAccessPage } from '../features/portal/PortalAccessPage';

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  {
    element: <MainLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      {
        element: <ProtectedRoute />,
        children: [
          // Printable documents render bare: no sidebar, header or breadcrumb.
          { path: 'quotations/:id/print', element: <QuotationPrintPage /> },
          { path: 'sales-invoices/:id/print', element: <SalesInvoicePrintPage /> },
          { path: 'sales-returns/:id/print', element: <SalesReturnPrintPage /> },
          { path: 'receipts/:id/print', element: <ReceiptPrintPage /> },
          { path: 'gate-passes/:id/print', element: <GatePassPrintPage /> },
          { path: 'stock/transfers/:id/print', element: <TransferPrintPage /> },
          {
            element: <DashboardLayout />,
            children: [
              { index: true, element: <OverviewPage /> },
              { path: 'users', element: <UsersPage /> },
              { path: 'roles', element: <RolesPage /> },
              { path: 'roles/new', element: <RoleEditorPage /> },
              { path: 'roles/:id/edit', element: <RoleEditorPage /> },
              { path: 'departments', element: <DepartmentsPage /> },
              {
                path: 'organization/companies',
                element: <OrgEntityPage config={ORG_ENTITIES['companies']!} />,
              },
              {
                path: 'organization/branches',
                element: <OrgEntityPage config={ORG_ENTITIES['branches']!} />,
              },
              {
                path: 'organization/warehouses',
                element: <OrgEntityPage config={ORG_ENTITIES['warehouses']!} />,
              },
              {
                path: 'organization/godowns',
                element: <OrgEntityPage config={ORG_ENTITIES['godowns']!} />,
              },
              {
                path: 'organization/gates',
                element: <OrgEntityPage config={ORG_ENTITIES['gates']!} />,
              },
              {
                path: 'organization/racks',
                element: <OrgEntityPage config={ORG_ENTITIES['racks']!} />,
              },
              {
                path: 'catalog/categories',
                element: <CatalogEntityPage config={CATALOG_ENTITIES['categories']!} />,
              },
              {
                path: 'catalog/brands',
                element: <CatalogEntityPage config={CATALOG_ENTITIES['brands']!} />,
              },
              {
                path: 'catalog/series',
                element: <CatalogEntityPage config={CATALOG_ENTITIES['series']!} />,
              },
              {
                path: 'catalog/collections',
                element: <CatalogEntityPage config={CATALOG_ENTITIES['collections']!} />,
              },
              { path: 'products', element: <ProductsPage /> },
              { path: 'products/rates', element: <PurchaseRatesPage /> },
              { path: 'products/prices', element: <SellingPricesPage /> },
              { path: 'products/weights', element: <ProductWeightsPage /> },
              { path: 'product-audit', element: <ProductAuditPage /> },
              { path: 'profit', element: <ProfitReportPage /> },
              { path: 'reports/product-transactions', element: <ProductTransactionReportPage /> },
              { path: 'reports/fast-moving', element: <FastMovingReportPage /> },
              { path: 'reports/product-sales', element: <ProductSalesReportPage /> },
              { path: 'reports/godown-sales', element: <GodownSalesReportPage /> },
              { path: 'reports/salesman-incentives', element: <IncentiveReportPage /> },
              { path: 'reports/incentive-products', element: <IncentiveProductListPage /> },
              { path: 'products/incentives', element: <IncentiveAssignPage /> },
              { path: 'reports/salesman-sales', element: <SalesmanSalesReportPage /> },
              {
                path: 'customers',
                element: <PartyEntityPage config={PARTY_ENTITIES['customers']!} />,
              },
              {
                path: 'suppliers',
                element: <PartyEntityPage config={PARTY_ENTITIES['suppliers']!} />,
              },
              {
                path: 'transporters',
                element: <LogisticsPage config={LOGISTICS_ENTITIES['transporters']!} />,
              },
              {
                path: 'vehicles',
                element: <LogisticsPage config={LOGISTICS_ENTITIES['vehicles']!} />,
              },
              {
                path: 'drivers',
                element: <LogisticsPage config={LOGISTICS_ENTITIES['drivers']!} />,
              },
              { path: 'stock', element: <StockPage /> },
              { path: 'stock/check', element: <StockCheckPage /> },
              { path: 'stock/product-check', element: <ProductStockCheckPage /> },
              { path: 'stock/product-activity', element: <ProductActivityReportPage /> },
              { path: 'stock/count', element: <StockCountPage /> },
              { path: 'stock/verification-report', element: <StockVerificationReportPage /> },
              { path: 'stock/smart-check', element: <SmartStockCheckPage /> },
              { path: 'stock/transfers', element: <TransfersPage /> },
              { path: 'stock/reports', element: <StockReportsPage /> },
              { path: 'stock/branch-godown-report', element: <BranchGodownStockReportPage /> },
              { path: 'stock/godown-report', element: <AllGodownStockReportPage /> },
              { path: 'stock/multiple-godowns', element: <MultiGodownStockReportPage /> },
              { path: 'stock/inactive-products', element: <InactiveProductStockReportPage /> },
              { path: 'purchase-orders', element: <PurchaseOrdersPage /> },
              { path: 'delivery-addresses', element: <DeliveryAddressesPage /> },
              { path: 'goods-receipts', element: <GoodsReceiptsPage /> },
              { path: 'purchase-invoices', element: <PurchaseInvoicesPage /> },
              { path: 'purchase-returns', element: <PurchaseReturnsPage /> },
              { path: 'quotations', element: <QuotationsPage /> },
              { path: 'quotations/new', element: <QuotationEntryPage /> },
              { path: 'quotations/:id/edit', element: <QuotationEntryPage /> },
              { path: 'crm', element: <LeadsPage /> },
              { path: 'crm/campaigns', element: <CampaignsPage /> },
              { path: 'crm/visits', element: <SalesVisitsPage /> },
              { path: 'sales-orders', element: <SalesOrdersPage /> },
              { path: 'sales-invoices', element: <SalesInvoicesPage /> },
              { path: 'granite-invoice', element: <GraniteInvoicePage /> },
              { path: 'granite-stock', element: <GraniteStockPage /> },
              { path: 'delivery-slips', element: <DeliverySlipsPage /> },
              { path: 'sales-returns', element: <SalesReturnsPage /> },
              { path: 'gate-passes', element: <GatePassesPage /> },
              { path: 'gate-passes/new', element: <GatePassEntryPage /> },
              { path: 'driver-cash', element: <DriverCashPage /> },
              { path: 'dispatch-reports', element: <DispatchReportsPage /> },
              { path: 'collections', element: <CollectionsPage /> },
              { path: 'outstanding', element: <OutstandingPage /> },
              { path: 'advances', element: <CustomerAdvancesPage /> },
              { path: 'customer-ledger', element: <CustomerLedgerPage /> },
              { path: 'gst-summary', element: <GstSummaryPage /> },
              { path: 'purchase-gst', element: <PurchaseGstPage /> },
              { path: 'supplier-payments', element: <SupplierPaymentsPage /> },
              { path: 'supplier-ledger', element: <SupplierLedgerPage /> },
              { path: 'payables', element: <PayablesPage /> },
              { path: 'number-series', element: <NumberSeriesPage /> },
              { path: 'portal-access', element: <PortalAccessPage /> },
              { path: 'accounts', element: <AccountsPage /> },
              { path: 'cash-book', element: <CashBookPage /> },
              { path: 'day-close', element: <DayClosePage /> },
              { path: 'owner-statement', element: <OwnerStatementPage /> },
              { path: 'expense-heads', element: <ExpenseHeadsPage /> },
              { path: 'settings', element: <SettingsPage /> },
              { path: 'backup-restore', element: <BackupRestorePage /> },
              { path: 'transaction-archive', element: <TransactionArchivePage /> },
              { path: 'wipe-data', element: <TransactionArchivePage /> },
              { path: 'access-calendar', element: <AccessCalendarPage /> },
              { path: 'sixorbit', element: <SixOrbitSettingsPage /> },
              { path: 'sixorbit/products', element: <ProductImportPage /> },
              { path: 'sixorbit/product-master-export', element: <ProductMasterExportPage /> },
              { path: 'sixorbit/stock-export', element: <SixOrbitStockExportPage /> },
              { path: 'sixorbit/sync-log', element: <SyncConsolePage /> },
              { path: 'sixorbit/pending-jobs', element: <PendingJobsPage /> },
              { path: 'audit', element: <AuditLogPage /> },
              { path: 'profile', element: <ProfilePage /> },
            ],
          },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
